import React from "react";

import { Hr } from "../Hr";
import { Logo } from "../Logo";

import "./Footer.scss";

export type FooterProps = {
  cx?: string;
  clickPrivacyPolicy: any;
  clickTerms: any;
};

export const Footer: React.FC<FooterProps> = ({
  cx = "",
  clickPrivacyPolicy,
  clickTerms,
}) => {
  return (
    <footer className={`Footer ${cx}`}>
      <section className={"sec-2"}>
        <Logo beta />
        <div className="r">
          <div className="links">
            <span onClick={clickPrivacyPolicy}>개인정보 처리방침</span>
            <span className={"bar"}>|</span>
            <span onClick={clickTerms}>이용약관</span>
          </div>
        </div>
      </section>
      <Hr />
      <section className={"sec-3"}>
        <div>ⓒ onmydev Corp. All Rights Reserved</div>
        <div className={"r"}>
          사업자등록번호 : 642-87-02235
          <span className={"bar"}>|</span>
          주소 : 경기도 성남시 분당구 황새울로 335번길 10, 5층 540호
          <br/>
          대표자 : 박헌영
          <span className={"bar"}>|</span>
          전화번호 : 031-709-5323
        </div>
      </section>
    </footer>
  );
};
